<template>
  <el-row :gutter="20" class="main_block">
    <div class="mianContent">
      <div class="tagView">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{
              $route.meta.title
            }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search">
        <el-form
            :model="searchParam"
            status-icon
            ref="searchData"
            label-position="left"
            label-width="90px"
            :inline="true"
        >
          <el-form-item label="">
            <el-select
                clearable
                v-model="searchParam.userStatus"
                placeholder="账号状态"
            >
              <el-option
                  v-for="item in accountType"
                  :key="item.val"
                  :label="item.name"
                  :value="item.val"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
                type="text"
                v-model="searchParam.username"
                autocomplete="off"
                placeholder="请输入登录账号"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
                type="text"
                v-model="searchParam.name"
                autocomplete="off"
                placeholder="请输入账号所有者名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="">
            <el-button
                type="primary"
                @click="selectTable"
            >查询
            </el-button
            >
            <el-button
                type="info"
                @click="
                                (searchParam = {page: 1,size: 10},pageSizeNum=10),
                                    selectTable()
                            "
            >重置
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-row type="flex" style="margin-bottom:20px" justify="center">
        <el-col :span="3">
          <el-button
              type="primary"
              @click="addChildren"
          >创建子账号
          </el-button
          >
        </el-col>
        <el-col :span="21" class="operation">
          <!-- <span><i class="el-icon-edit"></i>编辑</span> -->
          <span @click="handDisable"><i class="el-icon-remove-outline"></i>禁用</span>
          <span @click="handEnable"><i class="el-icon-video-pause"></i>解禁</span>
          <span @click="handDelete"><i class="el-icon-delete"></i>删除</span>
        </el-col>
      </el-row>
      <ExTable
          ref="multipleTable"
          tableName="table"
          :select="true"
          :isIndex="false"
          :table-list="tableData"
          :header="header"
          height="300"
          :total="total"
          :tableId="2"
          :activeIndex="searchParam.page"
          :pageSizeNum="pageSizeNum"
          @clickPage="clickPage"
          @clickSize="clickSize"
          @selection-change="handleSelectionChange"
      >
        <el-table-column slot="operate" label="操作" align="center" width="140" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <i class="el-icon-ali-bianji icon-btn" @click="handEdit(scope.row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="初始化密码" placement="top">
              <i class="el-icon-ali-chushihuamima icon-btn" @click="initPwd(scope.row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </ExTable>
    </div>
    <el-dialog
        :title="modalType=='add'?'创建子账号':'编辑子账号'"
        :visible.sync="addChildDia"
        width="60%"
        top="15vh"
        @close="closeDia"
        class="copyDialog mydia"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center>
      <el-form
          :model="createChildForm"
          :rules="createChildRules"
          ref="createForm"
          label-width="100px"
          class="diaruleForm"
      >
        <div class="baseMes">
          <div class="baseTitle">
            <span/>
            <p>基本信息</p>
          </div>

          <el-form-item
              label="子账号:"
              label-width="225px"
              prop="username"
          >
            <el-input
                :disabled="modalType=='add'?false : true"
                v-model="createChildForm.username"
                placeholder="用于子账号登录，6-20位英文或英文数字组合"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="密码:"
              label-width="225px"
              prop="password"
              v-if="modalType=='add'"
          >
            <el-input
                type="password"
                v-model="createChildForm.password"
                placeholder="用于子账号登录，6-16位数字或英文"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="确认密码:"
              label-width="225px"
              prop="confirmPassword"
              v-if="modalType=='add'"
          >
            <el-input
                type="password"
                v-model="createChildForm.confirmPassword"
                placeholder="请再次输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="名称:"
              label-width="225px"
              prop="ownerName"
          >
            <el-input
                v-model="createChildForm.ownerName"
                placeholder="请输入用户姓名 或 企业名称"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="子账号联系电话:"
              label-width="225px"
              prop="contractPhone"
          >
            <el-input
                v-model="createChildForm.contractPhone"
                placeholder="请输入子账号联系电话"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="子账号联系邮箱:"
              label-width="225px"
              prop="contractEmail"
          >
            <el-input
                v-model="createChildForm.contractEmail"
                placeholder="请输入子账号邮箱，便于发送子账号及密码"
            ></el-input>
            <!--            <p class="ts" v-if="modalType=='add'">子账号及密码发送至该邮箱</p>-->
          </el-form-item>
          <div class="baseMes baseMes2">
            <div class="baseTitle">
              <span/>
              <p>权限设置</p>
            </div>
            <p class="zhuyi">(注：子账号所有时间戳费用从主账号扣除，超过使用个数上限后，系统允许子账号有一次取证欠费)</p>
            <el-form-item label="子账号可使用时间戳数:" prop="access" label-width="225px">
              <el-select v-model="createChildForm.access" placeholder="请选择可使用时间戳数" @change="selectChange">
                <el-option label="限制个数" value="1"></el-option>
                <el-option label="不限个数" value="-1"></el-option>
              </el-select>
              <span class="ts2" v-if="show">*该账号使用个数已达上限</span>
            </el-form-item>
          </div>

          <el-form-item
              v-if="createChildForm.access && createChildForm.access!='-1'"
              label="最多限制使用时间戳数:"
              label-width="225px"
              prop="consumeTsLimitCount"
          >
            <el-input
                @input="createChildForm.consumeTsLimitCount=createChildForm.consumeTsLimitCount.replace(/\D|^/g, '')"
                v-model="createChildForm.consumeTsLimitCount"
                placeholder="请输入最多限制使用时间戳数"
            ></el-input>
          </el-form-item>
          <el-form-item
              label="子账号可使用平台:"
              label-width="225px"
              prop="grantType"
          >
            <el-checkbox-group v-model="createChildForm.grantType"
                               @change="grantTypeChange">
              <el-checkbox :label="955740" name="grantType">电子取证</el-checkbox>
              <el-checkbox :label="954210" name="grantType">权利卫士取证</el-checkbox>
              <el-checkbox :label="952310" name="grantType">知识产权保护</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div class="baseMes baseMes2"
               v-if="createChildForm.grantType.includes(954210)||createChildForm.grantType.includes(955740)"
          >
            <div class="baseTitle">
              <p>电子取证&权利卫士取证- 权限设置</p>
            </div>
            <div class="baseContent baseContent2">

              <el-form-item label-width="225px" label="可信时间戳认证证书-申请人:" prop="evApply">
                <el-radio-group v-model="createChildForm.evApply">
                  <el-radio :label="0">主账号名称</el-radio>
                  <el-radio :label="1">子账号名称</el-radio>
                  <el-radio :label="2">主账号名称+子账号名称</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label-width="225px" label="证据文件删除权限:" prop="evDelete">
                <el-radio-group v-model="createChildForm.evDelete">
                  <el-radio :label="0">可删除</el-radio>
                  <el-radio :label="1">不可删除</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label-width="225px" label="证据文件分享权限:" prop="evShare">
                <el-radio-group v-model="createChildForm.evShare">
                  <el-radio :label="0">可分享</el-radio>
                  <el-radio :label="1">不可分享</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>

          </div>
          <div class="baseMes" v-if="createChildForm.grantType.includes(952310)">
            <div class="baseTitle">
              <p>知识产权保护（包含软著认证）- 权限设置</p>
            </div>
            <div class="baseContent baseContent2">
              <el-form-item label-width="225px" label="可信时间戳认证证书-申请人:" prop="iprApply">
                <el-radio-group v-model="createChildForm.iprApply">
                  <el-radio :label="0">主账号名称</el-radio>
                  <!-- <el-radio :label="1">子账号名称</el-radio> -->
                  <el-radio :label="2">主账号名称+子账号名称</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label-width="225px" label="原件删除权限:" prop="iprFileDelete">
                <el-radio-group v-model="createChildForm.iprFileDelete">
                  <el-radio :label="0">可删除</el-radio>
                  <el-radio :label="1">不可删除</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label-width="225px" label="知产文件分享权限:" prop="iprShare">
                <el-radio-group v-model="createChildForm.iprShare">
                  <el-radio :label="0">可分享</el-radio>
                  <el-radio :label="1">不可分享</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer childFooter">
          <el-button
              style="margin-right: 24px"
              @click="closeDia"
          >
            取消
          </el-button>
         <el-button
             type="primary"
             @click="subForm('createForm')">
           确定
         </el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="子账号开通责任条款"
        :visible.sync="termsDia"
        width="800px"
        top="15vh"
        :show-close="false"
        class="copyDialog mydia"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        center>
      <div class="termsCnt">
        <p>开通子账号前您应充分了解并同意：</p>
        <p>1.您应对主账号及子账号的全部行为承担责任。</p>
        <p>2.子账号是基于主账号的分配而获得使用服务的权限，子账号的使用及操作等行为均视为主账号的行为。主账号应当对子账号进行管理，要求其在使用服务时遵守相关法律的规定且不得违反平台的相关协议。</p>
        <p>3.如果子账号出现违规使用的情形，您同意联合信任可直接对该违规的子账号进行相应的处理，包括中止或终止该子账号的服务。</p>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button style="padding:12px 40px" type="info" plain @click="goBack">不同意</el-button>
          <el-button style="padding:12px 40px" type="primary" @click="agree">我已阅读并同意</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import ExTable from "@com/ExTable";
import {formatDate, sourceType, filterParams} from "@/utils/filter";
import {
  getChildrenList,
  disableChildren,
  enableChildren,
  deleteChildren,
  creatChildren,
  updateChildren,
  initializePassword
} from "@http/sub_account/index";
import {identification, signUserInfo, signProtocol} from "@http/user_center/userInfo";

var initForm;
export default {
  data() {
    var space = (rule, value, callback) => {
      console.log(value)
      if (value.toString().replace(/\s/g, "") == '') {
        callback(new Error("输入内容不能全为空格"));
      }
      callback();
    };
    var constitute = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
      let reg2 = /^[a-zA-Z]{6,20}$/
      if (this.modalType == 'add') {
        if (!reg.test(value) && !reg2.test(value)) {
          callback(new Error("请输入6-20位英文或英文数字组合的子账号"));
        }
      }
      callback();
    };
    var pass = (rule, value, callback) => {
      let reg = /^[0-9a-zA-Z]{6,16}$/
      if (!reg.test(value)) {
        callback(new Error("请输入6-16位的数字或字母或数字与字母的组合"));
      }
      callback();
    };
    var confirm = (rule, value, callback) => {
      if (value !== this.createChildForm.password) {
        callback(new Error("您两次输入密码不一致，请重新输入"));
      }
      callback();
    };
    return {
      modalType: 'add', //edit 编辑
      addChildDia: false,
      termsDia: false,//条款弹框
      isSign: false,//是否需要签署协议
      createChildForm: {
        grantType: [],
        consumeTsLimitCount: ''
      },
      createChildRules: {
        username: [
          {required: true, message: '请输入子账号', trigger: 'change'},
          {validator: space, trigger: "blur"},
          // { min: 2, max: 20, message: '请输入2-32位之间的字符', trigger: 'blur' },
          {validator: constitute, trigger: "blur"},
        ],
        certNameStatus: [
          {required: true, message: '请选择证书申请人', trigger: 'change'},
        ],
        recyclerStatus: [
          {required: true, message: '请选择证据及文件管理权限', trigger: 'change'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'change'},
          {validator: space, trigger: "blur"},
          {min: 6, max: 16, message: '请输入6-16位密码', trigger: 'change'},
          {validator: pass, trigger: "blur"},
        ],
        confirmPassword: [
          {required: true, message: '请确认密码', trigger: 'change'},
          {validator: confirm, trigger: "blur"},
          {min: 6, max: 16, message: '请输入6-16位密码', trigger: 'blur'},
        ],
        ownerName: [
          {required: true, message: '请输入用户姓名 或 企业名称', trigger: 'change'},
          {validator: space, trigger: "blur"},
          {min: 1, max: 50, message: '请输入50个字内的名称', trigger: 'change'},
        ],
        grantType: [
          {type: 'array', required: true, message: '请至少选择一个可使用平台', trigger: 'change'}
        ],
        consumeTsLimitCount: [
          {required: true, message: '请输入限制个数', trigger: 'change'},
          {validator: space, trigger: "blur"},
        ],
        access: [
          {required: true, message: '请选择最高使用个数上限', trigger: 'change'}
        ],
        evApply: [
          {required: true, message: '请设置申请人信息', trigger: 'change'}
        ],
        evDelete: [
          {required: true, message: '请选择证据文件删除权限', trigger: 'change'}
        ],
        evShare: [
          {required: true, message: '请选择证据文件分享权限', trigger: 'change'}
        ],
        iprApply: [
          {required: true, message: '请设置申请人信息', trigger: 'change'}
        ],
        iprFileDelete: [
          {required: true, message: '请选择原件删除权限', trigger: 'change'}
        ],
        iprShare: [
          {required: true, message: '请选择知产文件分享权限', trigger: 'change'}
        ],
      },
      accountType: [
        {
          val: 0,
          name: "未激活",
        },
        {
          val: 1,
          name: "正常",
        },
        {
          val: 2,
          name: "禁用",
        },
        // {
        //     val: 3,
        //     name: "注销",
        // },
        // {
        //     val: 4,
        //     name: "异常",
        // },
      ],
      searchParam: {
        page: 1,
        size: 10,
        username: "",
        name: "",
        userStatus: '',
      },
      pageSizeNum: 10,
      tableData: [],
      header: [
        // {
        //     checkBox: true,
        //     formatter: (row) => {
        //         if(row.userStatus==2){
        //             return false
        //         }else{
        //             return true
        //         }
        //     },
        // },
        // { prop: "id", label: "ID",minWidth:100, },
        {
          prop: "username",
          label: "账号",
          minWidth: 120,
        },
        {
          prop: "ownerName",
          label: "账号所有者名称",
          minWidth: 120,
        },
        {
          minWidth: 150,
          label: "联系方式",
          render: (h, data) => {
            if (!data.row.contractPhone && !data.row.contractEmail) {
              return (
                  <div>--</div>
              )
            } else if (data.row.contractPhone && data.row.contractEmail) {
              return (
                  <ul>
                    <li>
                      电话：{data.row.contractPhone}
                    </li>
                    <li>
                      邮箱：{data.row.contractEmail}
                    </li>
                  </ul>
              )
            } else if (!data.row.contractPhone && data.row.contractEmail) {
              return (
                  <ul>
                    <li>
                      邮箱：{data.row.contractEmail}
                    </li>
                  </ul>
              )
            } else if (data.row.contractPhone && !data.row.contractEmail) {
              return (
                  <ul>
                    <li>
                      电话：{data.row.contractPhone}
                    </li>
                  </ul>
              )
            }

          }
        },
        {
          prop: "grantType",
          minWidth: 200,
          label: "可使用平台",
          render: (h, data) => {
            let platNumArry = [];
            if (!data.row.grantType) {
              return ''
            }
            if (data.row.grantType.indexOf(',') != -1) {
              platNumArry = data.row.grantType.split(',');
            } else {
              platNumArry = [data.row.grantType];
            }

            if (platNumArry.length > 0) {
              let platNameArry = [];
              for (let i = 0; i < platNumArry.length; i++) {
                // console.log(sourceType(parseInt(platNumArry[i])))
                platNameArry.push(sourceType(parseInt(platNumArry[i])))
              }
              return platNameArry.map((item, index) => {
                if (index < platNameArry.length - 1) {
                  return (
                      <span>{item}、</span>
                  )
                } else {
                  return (
                      <span>{item}</span>
                  )
                }

              })
            } else {
              return ''
            }

          }
        },
        // {
        //   width: 150,
        //   prop: "certNameStatus",
        //   label: "证书申请人",
        //   formatter: (row) => {
        //     if (row.certNameStatus == 1) {
        //       return '主账号名称+子账号名称'
        //     } else if (row.certNameStatus == 0) {
        //       return "主账号名称"
        //     } else {
        //       return "子账号名称"
        //     }
        //   },
        // },
        // {
        //   width: 170,
        //   prop: "recyclerStatus",
        //   label: "证据及文件管理权限",
        //   formatter: (row) => {
        //     if (row.recyclerStatus == 0) {
        //       return '可删除'
        //     } else {
        //       return '不可删除'
        //     }
        //   },
        // },
        // {
        //   width: 170,
        //   prop: "recyclerStatus",
        //   label: "证据及文件分享权限",
        //   formatter: (row) => {
        //     if (row.sharingStatus == 0) {
        //       return '可分享'
        //     } else {
        //       return '不可分享'
        //     }
        //   },
        // },
        {
          minWidth: 120,
          prop: "consumeTsLimitCount",
          label: "使用个数上限",
          formatter: (row) => {
            if (row.consumeTsLimitCount == -1) {
              return '无限制'
            } else {
              return row.consumeTsLimitCount + '个'
            }
          },
        },
        {
          minWidth: 120,
          prop: "currentTsLimitCount",
          label: "已使用个数",
          formatter: (row) => {
            return row.currentTsLimitCount + '个'
          },
        },
        {
          minWidth: 70,
          prop: "userStatus",
          label: "状态",
          render: (h, data) => {
            switch (data.row.userStatus) {
              case 0:
                return (<span style="color:#999">未激活</span>);
                break;
              case 1:
                return (<span style="color:#4F9E48">正常</span>);
                break;
              case 2:
                return (<span style="color:red">禁用</span>);
                break;
              case 3:
                return (<span>注销</span>);
                break;
              case 4:
                return (<span>异常状态用户</span>);
                break;
            }
          },
        },
        {
          minWidth: 120,
          prop: "updatedAt",
          label: "更新时间",
          formatter: (row) => {
            if (row.updatedAt) {
              return formatDate(row.updatedAt);
            } else {
              return '--'
            }

          },
        },
        {
          slot: 'operate',
        },
      ],
      total: 10,
      selectionId: [],//选择的行
      selectionRow: [],
      isEnvApp: false,
      isIpr: false,
    };
  },

  components: {
    ExTable,
  },

  computed: {
    show() {
      if (this.modalType == 'edit') {
        if (this.createChildForm.access == '1') {
          if (this.createChildForm.consumeTsLimitCount !== '') {
            if (!(this.createChildForm.currentTsLimitCount < this.createChildForm.consumeTsLimitCount)) {
              return true;
            }
          }
        }
      }
      return false;
    },
    channelCodeValue(){
        return this.$store.state.config.channelCodeValue;
    },
  },

  created() {
    initForm = JSON.stringify(this.createChildForm);
    this.getTableData(filterParams(this.searchParam))
    signUserInfo().then((res) => {
      if (res.subUserProtocolUpdateStatus == 1) {
        this.termsDia = true;
      }
    }).catch((err) => {
      console.log(err)
    })
  },

  mounted() {
    zhuge.track('用户中心_进入子账号管理', {'渠道': this.channelCodeValue})
  },

  methods: {
    goBack(){
      if(window.history.length<=1){//判断有没有上级路由；
        this.$router.push({path:'/Home'})
      }else{
        this.$router.go(-1); //返回上级路由
      }
    },
    async getTableData(data) {
      let res = await getChildrenList(data);
      console.log(res)
      this.tableData = res.data;
      this.total = res.total;
    },
    selectTable() {
      this.searchParam.page = 1;
      this.getTableData(filterParams(this.searchParam));
    },
    clickPage(page) {
      this.searchParam.page = page;
      this.getTableData(filterParams(this.searchParam));
    },
    clickSize(size) {
      this.searchParam.page = 1;
      this.searchParam.size = size;
      this.pageSizeNum = size;
      this.getTableData(filterParams(this.searchParam));
    },
    async handDisable() {
      let pass = this.selectionRow.find((item) => {
        return item.userStatus == 2;
      })
      if (pass) {
        this.$msg('禁用状态的子账号无法再次禁用，请选择状态为正常用户的子账号进行禁用操作', 'error', 8000);
        this.$refs.multipleTable.$refs.table.clearSelection();
        return false;
      }
      if (this.selectionId.length > 0) {
        let res = await disableChildren({childId: this.selectionId});
        if (res.code == 200) {
          this.$refs.multipleTable.$refs.table.clearSelection();
          this.$msg(res.message, "success");
          this.getTableData(filterParams(this.searchParam));
          console.log(res)
        }
      } else {
        this.$msg('请选择要禁用的子账号');
      }
    },
    async handEnable() {
      if (this.selectionId.length > 0) {
        let res = await enableChildren({childId: this.selectionId});
        if (res.code == 200) {
          this.$refs.multipleTable.$refs.table.clearSelection();
          this.$msg(res.message, "success");
          this.getTableData(filterParams(this.searchParam));
          console.log(res)
        }
      } else {
        this.$msg('请选择要启用的子账号');
      }
    },
    handDelete() {
      let that = this
      let pass = this.selectionRow.find((item) => {
        return item.userStatus !== 2;
      })
      if (pass) {
        this.$msg('只有禁用状态的子账号才能删除，请重新选择要删除的子账号');
        this.$refs.multipleTable.$refs.table.clearSelection();
        return false;
      }
      if (this.selectionId.length > 0) {
        this.$confirm('此操作将永久删除该子账号, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await deleteChildren({childId: that.selectionId});
          if (res.code == 200) {
            this.$refs.multipleTable.$refs.table.clearSelection();
            this.$msg(res.message, "success");
            this.getTableData(filterParams(this.searchParam));
            console.log(res)
          }
        }).catch(() => {
          this.$refs.multipleTable.$refs.table.clearSelection();
          console.log('取消')
        });
      } else {
        this.$msg('请选择要删除的子账号');
      }
    },
    addForm() {
      this.modalType = 'add';
      this.addChildDia = true;
      if (!this.$refs.createChildForm) {
        this.$nextTick(() => {
          this.createChildForm = JSON.parse(initForm);
          this.$refs.createForm.resetFields() // 去除验证
        })
      } else {
        this.createChildForm = JSON.parse(initForm);
        this.$refs.ruleForm.resetFields() // 去除验证
      }
    },
    async addChildren() {
        zhuge.track('用户中心_创建子账号', {'渠道': this.channelCodeValue})
      let res = await identification();
      if (res?.status !== 1) {
        this.$msg('请先进行实名认证通过后再进行子账号的创建');
      } else {
        this.addForm()
      }
    },
    agree() {
      this.termsDia = false;
      signProtocol({protocolType: 'SUBUSER'}).then((res) => {
        console.log('签署成功')
      }).catch((err) => {
        this.$msg('协议签署异常，请重试');
      })
    },
    handleSelectionChange(val) {
      this.selectionRow = val;
      this.selectionId = val.map((item) => {
        return item.id
      });
      console.log(this.selectionId)
    },
    subForm(formName) {
        if (this.modalType == 'add') {
            zhuge.track('用户中心_确定创建子账号', {'渠道': this.channelCodeValue})
        }
        if(this.createChildForm.iprApply===1){
          this.createChildForm.iprApply=''
        }
      this.$refs[formName].validate(async (valid) => {
        console.log(this.createChildForm);
        if (valid) {
          let dataObj = {};
          for (var key in this.createChildForm) {
            if (key == "grantType") {
              dataObj[key] = this.createChildForm[key].join(',');
            } else if (key == "consumeTsLimitCount") {
              dataObj[key] = parseInt(this.createChildForm[key]);
            } else if(key=="ownerName"){
                dataObj[key] = this.createChildForm[key].replace(/\s+/g, " ").trim();
            }else if (typeof (this.createChildForm[key]) == "string") {
              dataObj[key] = this.createChildForm[key].replace(/\s/g, "");
            } else {
              dataObj[key] = this.createChildForm[key];
            }
          }
          if (dataObj.access == '-1') {
            dataObj.consumeTsLimitCount = -1;
          }
          let res;
          if (this.modalType == 'add') {
            delete dataObj.access;
            delete dataObj.confirmPassword;
            res = await creatChildren(dataObj);
          } else {
            delete dataObj.password;
            delete dataObj.username;
            delete dataObj.access;
            delete dataObj.confirmPassword;
            res = await updateChildren(dataObj);
          }
          if (res.code == 200) {
            this.$msg(res.message, "success");
            this.getTableData(filterParams(this.searchParam));
            this.addChildDia = false;
            this.$refs[formName].resetFields();
          }
        } else {
          return false;
        }
      })
    },
    handEdit(row) {
        zhuge.track('用户中心_编辑子账号', {'渠道': this.channelCodeValue})
      this.modalType = 'edit';
      let dataObj = {};
      for (let key in row) {
        if (key == 'grantType') {
          if (row[key]) {
            dataObj[key] = row[key].split(',').map(Number)
          } else {
            dataObj[key] = []
          }

          console.log(dataObj[key])
        } else {
          dataObj[key] = row[key];
        }
      }
      if (dataObj.consumeTsLimitCount == '-1') {
        dataObj.access = '-1'
      } else {
        dataObj.access = '1'
      }
      this.createChildForm = dataObj;
      this.addChildDia = true;
    },
    selectChange(val) {
      console.log(val)
      if (val == 1) {
        this.createChildForm.consumeTsLimitCount = ''
      }
    },
    closeDia() {
      // this.clearForm()
      this.createChildForm = JSON.parse(initForm);
      this.$refs.createForm.resetFields();
      this.addChildDia = false;
    },
    clearForm() {
      this.$nextTick(e => {
        if (this.$refs.createChildForm) {
          this.$refs.createForm.clearValidate()
          this.$refs.createForm.resetFields() // 去除验证
        }
      })
    },
    grantTypeChange(e) {

    },
    initPwd(row) {
        zhuge.track('用户中心_子账号初始化密码', {'渠道': this.channelCodeValue})
      this.$confirm('此操作将初始化该子账号密码, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await initializePassword({
          childId: row.id,
        });
        console.log(res)
        if (res.password) {
          this.$alert(`该子账号密码已初始化为“${res.password}”,请使用者及时修改,方便后续登录`, '密码初始化成功', {
            confirmButtonText: '确定',
            callback: action => {
              console.log('成功')
            }
          });
          this.getTableData(filterParams(this.searchParam));
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消初始化密码操作'
        });
      });
    }
  },
};
</script>
<style lang="less" scoped>
.diaruleForm {
  margin: 0 auto;
}

.search {
  padding-top: 20px;
}

.operation {
  text-align: right;

  span {
    display: inline-block;
    cursor: pointer;
    color: #3f7df7;
    font-size: 14px;
    line-height: 40px;
    margin-left: 20px;

    i {
      display: inline-block;
      margin-right: 5px;
    }
  }
}

.ts {
  line-height: 10px;
  margin-top: 5px;
  color: #ff6600;
  font-size: 12px;
  margin-bottom: 5px;
}

.ts2 {
  line-height: 10px;
  margin-top: 5px;
  color: red;
  font-size: 12px;
  margin-bottom: 5px;
  margin-left: 10px;
}

.zhuyi {
  font-size: 12px;
  font-weight: 400;
  color: #9C9C9C;
  width: 660px;
  margin-top: 10px;
  margin-bottom: 16px;

}

.termsCnt {
  p {
    text-indent: 2em;
    font-size: 14px;
    line-height: 25px;
  }
}

.mydia {
  .baseMes {
    margin-bottom: 16px;

    .baseTitle {
      span {
        width: 4px;
        height: 16px;
        background: #409EFF;
        display: inline-block;
        margin-right: 5px;
        float: left;
        margin-top: 2px;
      }

      p {
        font-size: 16px;
        font-weight: 600;
        color: #000000;
        display: inline-block;
      }
    }

    .baseContent {
      background: #F6F6F6;
      border-radius: 4px;
      border: 1px solid #D8D8D8;
      margin-top: 9px;
      height: 153px;
    }

    .baseContent2 {
      .el-form-item {
        margin-bottom: 5px;
      }
      /deep/.el-form-item__error{
        padding-top: 0;
      }
    }
  }

  .baseMes2 {
    margin-bottom: 13px;
  }

  /deep/ .el-dialog {
    border-radius: 8px;

  }

  /deep/ .el-dialog__header {
    background: #FAFAFA;
    padding: 16px 23px 16px 23px;
    border-radius: 8px 8px 0px 0px;

    .el-dialog__title {
      font-size: 18px;
      font-weight: 600;
      color: #000000;
    }

    .el-dialog__close {
      line-height: 14px;
    }
  }

  /deep/ .el-dialog__body {
    background: #fff;
    padding: 25px 25px 0px 30px;
    border-radius: 8px;
  }

  /deep/ .el-form-item__label {
    font-weight: 400;
    color: #000000;
    font-size: 14px;
  }

  /deep/ .el-form-item {
    margin-bottom: 16px;
  }

  .el-input {
    width: 78%;
  }

  /deep/ .childFooter {
    background: #fff;

    .el-button {
      width: 104px;
      height: 40px;
      border-radius: 4px;
      text-align: center;
      font-weight: 600;
    }
  }
}

/deep/ .el-input__suffix-inner .el-input__icon{
  //line-height: 28px;
}
</style>